import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, RefreshCw, Search } from "lucide-react";
import api, { readError } from "../api";

const states = [
  { key: "approved", label: "Onay", color: "#059669" },
  { key: "rejected", label: "Red", color: "#dc2626" },
  { key: "pending", label: "Bekleme", color: "#d97706" },
];

export const ApprovalAnalytics = ({ refreshKey }) => {
  const [days, setDays] = useState("0");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(true);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setBusy(true); setError("");
    const timer = setTimeout(() => {
      api.get("/dashboard/approvals", { params: { days, search, page }, signal: controller.signal })
        .then(({ data }) => setData(data))
        .catch(err => { if (!controller.signal.aborted) setError(readError(err, "Onay analitiği yüklenemedi")); })
        .finally(() => { if (!controller.signal.aborted) setBusy(false); });
    }, 200);
    return () => { clearTimeout(timer); controller.abort(); };
  }, [days, search, page, refreshKey, retry]);
  const pages = Math.max(1, Math.ceil((data?.customer_count || 0) / 8));
  return <section className="approval-analytics" data-testid="approval-analytics" aria-busy={busy}>
    <div className="approval-chart-head">
      <div><p className="eyebrow blue">MÜŞTERİ KARARLARI</p><h2>Onay / red / bekleme</h2>
        <span className="muted" data-testid="approval-scope">Taslaklar hariç · Her teklifin son revizyonu</span></div>
      <div className="approval-filters">
        <label className="search-box"><Search size={15} /><input aria-label="Müşteri ara" placeholder="Müşteri ara"
          data-testid="approval-customer-search" value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} /></label>
        <select aria-label="Teklif tarihi" data-testid="approval-period" value={days} onChange={e => { setDays(e.target.value); setPage(1); }}>
          <option value="0">Tüm tarihler</option><option value="30">Son 30 gün</option>
          <option value="90">Son 90 gün</option><option value="180">Son 180 gün</option>
        </select>
      </div>
    </div>
    <div className="approval-legend" data-testid="approval-legend">
      {states.map(s => <span key={s.key} data-testid={`approval-legend-${s.key}`}><i style={{ background: s.color }} />{s.label}
        {data && <b>{data[s.key]}</b>}</span>)}
      {data && <small data-testid="approval-total">{data.quote_count} teklif · {data.customer_count} müşteri</small>}
    </div>
    {busy ? <p className="muted" data-testid="approval-loading">Yükleniyor…</p>
      : error ? <div role="alert" data-testid="approval-error"><p>{error}</p><button className="outline-button" data-testid="approval-retry" onClick={() => setRetry(v => v + 1)}><RefreshCw size={14} />Tekrar dene</button></div>
      : !data?.customers.length ? <p className="analytics-empty" data-testid="approval-empty">Bu filtrelerde değerlendirmeye alınmış teklif yok.</p>
      : <div className="approval-bars" data-testid="approval-chart">
        {data.customers.map((customer, i) => <div className="approval-customer-row" key={customer.customer_key} data-testid={`approval-customer-${i}`}>
          <div className="approval-customer-label"><b data-testid={`approval-customer-name-${i}`}>{customer.customer_name}</b><small>{customer.total} teklif</small></div>
          <div className="approval-bar-detail">
            <div className="approval-stacked-bar" role="img" aria-label={`${customer.customer_name}: ${states.map(s => `${s.label} %${customer[`${s.key}_rate`]}`).join(", ")}`} data-testid={`approval-bar-${i}`}>
              {states.filter(s => customer[s.key] > 0).map(s => <span key={s.key} style={{ flexGrow: customer[s.key], background: s.color }}
                title={`${s.label}: ${customer[s.key]} teklif (%${customer[`${s.key}_rate`]})`} data-testid={`approval-segment-${i}-${s.key}`} />)}
            </div>
            <div className="approval-percentages">{states.map(s => <span key={s.key} data-testid={`approval-rate-${i}-${s.key}`}>
              <i style={{ background: s.color }} />{s.label} %{customer[`${s.key}_rate`].toLocaleString("tr-TR")} <small>({customer[s.key]})</small>
            </span>)}</div>
          </div>
        </div>)}
      </div>}
    <div className="approval-pagination">
      <small className="muted" data-testid="approval-excluded">{data?.excluded_drafts || 0} taslak kapsam dışında</small>
      <div><button className="icon-button" title="Önceki müşteriler" data-testid="approval-prev" disabled={page <= 1 || busy} onClick={() => setPage(p => p - 1)}><ChevronLeft size={17} /></button>
        <span data-testid="approval-page">{page} / {pages}</span>
        <button className="icon-button" title="Sonraki müşteriler" data-testid="approval-next" disabled={page >= pages || busy} onClick={() => setPage(p => p + 1)}><ChevronRight size={17} /></button></div>
    </div>
  </section>;
};